/* lawyerShare — مَنطق مُشارَكة بِطاقة المحامي عَلى منصّات التَّواصل.
   يَبني رابط `/api/lawyers/{slug}/share` الذي يَحوي OG-Image مُخَصَّص. */
import { LEXIQ_BRAND, LEXIQ_TAGLINE } from "./clientReminder";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function buildShareUrl(slug) {
  if (!slug) return "";
  return `${BACKEND}/api/lawyers/${encodeURIComponent(slug)}/share`;
}

export function buildShareMessage({ name, specialty, city, slug }) {
  const url = buildShareUrl(slug);
  const lines = [
    `*${name || "محامٍ"}* — مَحامٍ مُسَجَّل على ${LEXIQ_BRAND}`,
  ];
  if (specialty) lines.push(`الاختصاص: ${specialty}`);
  if (city) lines.push(`الموقع: ${city}`);
  lines.push("");
  lines.push("اطّلع على ملفّه الكامل وتَواصَل معه مباشرةً:");
  lines.push(url);
  lines.push("");
  lines.push("━━━━━━━━━━━━━━");
  lines.push(`⚖️ ${LEXIQ_BRAND} — ${LEXIQ_TAGLINE}`);
  return lines.join("\n");
}

export function buildWhatsappShareLink(payload) {
  return `https://wa.me/?text=${encodeURIComponent(buildShareMessage(payload))}`;
}

export async function copyShareUrl(slug) {
  const url = buildShareUrl(slug);
  if (!url) throw new Error("no-slug");
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(url);
    return url;
  }
  // fallback
  const ta = document.createElement("textarea");
  ta.value = url;
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand("copy"); } finally { ta.remove(); }
  return url;
}

export async function nativeShare(payload) {
  if (typeof navigator.share !== "function") return false;
  try {
    await navigator.share({
      title: `${payload.name} — LEXIQ`,
      text: buildShareMessage(payload),
      url: buildShareUrl(payload.slug),
    });
    return true;
  } catch {
    return false;
  }
}
